import { defineQueryOptions } from '@pinia/colada';
import { api, ApiError } from './client.ts';
import { meetsStaleView, messageOf } from './serverFailure.ts';
import type { Song } from './song.ts';

export const suggestionKeys = {
  root: ['suggestions'] as const,
  of: (search: string) => ['suggestions', search] as const,
};

const searchSongs = async (search: string): Promise<Song[]> => {
  const { data, error, response } = await api.GET('/game/suggestions', { params: { query: { search } } });
  if (error && meetsStaleView(error.slug)) return [];
  if (!data) throw new ApiError(response.status, error && messageOf('searchSongs', error), error?.slug);
  return data;
};

export const suggestionsQuery = defineQueryOptions((search: string) => ({
  key: suggestionKeys.of(search),
  query: () => searchSongs(search),
  enabled: search !== '',
  placeholderData: (previous: Song[] | undefined) => previous,
}));
